<div class="form-modal--wrapper">
    <div class="scroll">
        <eidos-light-form #modalForm [submitButtonClass]="'d-none'" [createButtonClass]="'d-none'"
          [formCanBeEmpty]="true"
          [clearButtonClass]="'d-none'" [fields]="modalData.fields" [(formValues)]="modalData.values"
          [mode]="modalData.mode || 'default'" (onFormSubmit)="onFormSubmit()">
        </eidos-light-form>
    </div>
    <div class="form-modal--actions fixed">
        <button class="eidos-button eidos-button-outlined eidos-button-big eidos-button-cancel" (click)="onCloseModalClick()">CANCEL</button>
        <button class="eidos-button eidos-button-outlined eidos-button-big eidos-button-success" (click)="onCloseModalClick(true)">CONFIRM</button>
    </div>
</div>
